import { Page } from '@/core/architecture'

import { ConsolePostDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePostDetail Page
 * Implemented as a practical sample.
 */
export const ConsolePostDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePostDetailTemplate state={state} {...actions} />
}
